exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.setBut{\n    padding:0 10px 15px;\n    margin-bottom:15px;\n    border-bottom: 1px solid #ddd;\n}\n.lookDel{\n    text-align: center;\n    padding: 10px;\n}\n.titleHead{\n    width: 100%;\n    font-weight: bold;\n    font-size: 20px;\n    text-align: center;\n    padding-bottom: 15px;\n}\n.setCaption{\n    height:40px;\n    line-height:40px;\n    font-size:14px;\n    padding:0 20px 0 20px;\n}\n.leftCaption{\n    display: inline-block;\n    float: left;\n    font-size:14px;\n}\n.rightCaption{\n    display: inline-block;\n    float: right;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d461da80","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/reports/reportsDetail.vue
// module id = uJru
// module chunks = 1